export function renderEmailPreview(emailTemplate: string | undefined) {
  if (!emailTemplate) {
    return "...";
  }
  let text = emailTemplate.replaceAll("$salutation", "Herr");
  text = text.replaceAll("$full_name", "Max Muster");
  text = text.replaceAll("$first_name", "Max");
  text = text.replaceAll("$last_name", "Muster");
  text = text.replaceAll("$ll_salutation", "Herr");
  text = text.replaceAll("$ll_full_name", "Jens Jämmerli");
  text = text.replaceAll("$ll_first_name", "Jens");
  text = text.replaceAll("$ll_last_name", "Jämmerli");
  text = text.replaceAll("$group_name", "API-1");
  text = text.replaceAll("$coach_salutation", "Frau");
  text = text.replaceAll("$coach_full_name", "Annina Schindler");
  text = text.replaceAll("$date", "22. August 2025");
  return text.replaceAll("$document_link", '<a href="https://example.org">Dokument</a>');
}
